/**
 * BroadcastTips - Dicas e informações sobre broadcast
 */
import React from 'react'
import { Bell, Mail, Users, Send, Copy } from 'lucide-react'
import Card from '../../components/atoms/Card'

const BroadcastTips = ({ showBothTip = false }) => {
	return (
		<div className="space-y-6">
			<Card className="p-6">
				<h3 className="text-lg font-semibold text-text mb-4">Dicas</h3>
				<div className="space-y-3 text-sm text-text-body">
					<p>
						<Bell className="w-4 h-4 inline mr-2 text-blue-500" />
						<strong className="text-text">Notificações Push</strong> são ideais para mensagens urgentes e curtas.
					</p>
					<p>
						<Mail className="w-4 h-4 inline mr-2 text-green-500" />
						<strong className="text-text">E-mails</strong> são melhores para comunicados mais longos.
					</p>
					<p>
						<Users className="w-4 h-4 inline mr-2 text-purple-500" />
						Escolha a <strong className="text-text">audiência</strong> com cuidado para não incomodar os usuários.
					</p>
				</div>
			</Card>

			{showBothTip && (
				<Card className="p-6 border-purple-500/30">
					<div className="flex items-center gap-2 mb-3">
						<Send className="w-5 h-5 text-purple-500" />
						<h3 className="text-lg font-semibold text-text">Modo Ambos</h3>
					</div>
					<p className="text-sm text-text-body">
						Você pode ter conteúdos diferentes para Push e Email.
						Use os botões <Copy className="w-3 h-3 inline" /> para copiar o conteúdo de um canal para o outro.
					</p>
				</Card>
			)}
		</div>
	)
}

export default BroadcastTips
